// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_te-0";